export default defineNuxtRouteMiddleware(async (to, from) => {
  const { data: session } = useAuth()

  if (!session.value?.user?.id) {
    throw createError({
      statusCode: 401,
      statusMessage: 'Authentication required',
    })
  }

  try {
    // Fetch current user's role from the database
    const response = (await $fetch(
      `/api/admin/users/${session.value.user.id}`
    )) as { data: { role: string } }
    const user = response.data

    if (!user || user.role !== 'ADMIN') {
      throw createError({
        statusCode: 403,
        statusMessage: 'Admin access required',
      })
    }
  } catch (error: any) {
    if (error.statusCode === 404) {
      // User has been deleted, redirect to login
      await navigateTo('/auth/login')
      return
    }

    if (error.statusCode === 403 || error.statusCode === 401) {
      throw error
    }

    // If there's an error fetching user data, deny access
    throw createError({
      statusCode: 403,
      statusMessage: 'Access denied',
    })
  }
})
